import { Component, Inject, Input, ViewChild } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { NbDatepickerDirective } from '@nebular/theme';
import { EntityProperty, FILTER_COLUMN_DATA } from 'src/app/shared/utils/filter-column-data';

@Component({
  selector: 'adm-date-filter',
  templateUrl: './date-filter.component.html',
  styleUrls: ['./date-filter.component.scss'],
})
export class DateFilterComponent implements ControlValueAccessor {
  @ViewChild(NbDatepickerDirective, { static: true }) public valueAccessor: ControlValueAccessor;
  @Input() public placeholder: string;

  constructor(control: NgControl, @Inject(FILTER_COLUMN_DATA) columnData: EntityProperty) {
    control.valueAccessor = this;
    this.placeholder = columnData.title;
  }

  public writeValue(value: any): void {
    this.valueAccessor.writeValue(value);
  }

  public registerOnChange(fn: any): void {
    this.valueAccessor.registerOnChange(fn);
  }

  public registerOnTouched(fn: any): void {
    this.valueAccessor.registerOnTouched(fn);
  }

  public setDisabledState(isDisabled: boolean): void {
    this.valueAccessor.setDisabledState(isDisabled);
  }
}
